import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import RetourAffectif from "./pages/services/RetourAffectif";
import { PageSeo } from './components/PageSeo';
import RestoredPage from './pages/RestoredPage';
import NotFound from './pages/NotFound';
import restored from './data/restored-pages.cjs';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageSeo />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/retour-affectif-guadeloupe" element={<RetourAffectif />} />
          {Object.keys(restored.restoredPages).map((path) => <Route caseSensitive key={path} path={path} element={<RestoredPage />} />)}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
